import type { Range } from "@tiptap/core";

import type { MinimalDocState } from "./types";

export const insertNodeAtRange = ({ editor, range, name, attrs }: any) => {
  const nodeAfter = editor.view.state.selection.$to.nodeAfter;
  const shouldOverrideSpace = nodeAfter?.text?.startsWith(" ");
  if (shouldOverrideSpace) {
    range.to += 1;
  }
  editor
    .chain()
    .focus()
    .insertContentAt(range, [
      {
        type: name,
        attrs,
      },
      {
        type: "text",
        text: " ",
      },
    ])
    .run();
};

export const checkIfContentMatches = ({ state, range, name }: any) => {
  const $from = state.doc.resolve(range.from);
  const type = state.schema.nodes[name];
  return !!$from.parent.type.contentMatch.matchType(type);
};

interface DoesQueryStartWithSpaceParams {
  char: string;
  range: Range;
  state: MinimalDocState;
}

/**
 * Suggestions configured with `allowSpaces` keep matching once the trigger char
 * is followed by a space, so a bare "@ " would stay active and swallow Enter.
 */
export const doesQueryStartWithSpace = ({
  state,
  range,
  char,
}: DoesQueryStartWithSpaceParams) =>
  /^\s/.test(state.doc.textBetween(range.from, range.to).slice(char.length));
